/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-19 17:42:59
 * @LastEditors: K
 * @LastEditTime: 2022-09-28 16:37:13
 */
import { MinusCircleOutlined, PlusCircleOutlined, SwapLeftOutlined } from '@ant-design/icons';
import { Col, Form, Input, Modal, notification, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { stringTrim } from '../../../utils/StringUtils';
import styles from './Partner.module.css'
interface HerbsDirectoryModalProps {
  visible: boolean
  editData?: any
  onOk: (obj: any) => void
  onCancel: () => void
  btnLoading: boolean
}

export const HerbsDirectoryModal = ({
  visible,
  editData,
  onOk,
  onCancel,
  btnLoading
}: HerbsDirectoryModalProps): ReactElement => {

  const [form] = Form.useForm()

  const [iptArr, setIptArr] = useState<any>([])

  const [sureBtnLoading, setSureBtnLoading] = useState(false)

  const addIConFn = () => {   
    if (iptArr.length == 10) {
      notification.info({ message: '已达到添加最高上限' })
      return
    }
    setIptArr([...iptArr, { name: '' }])
  }
  useEffect(() => {    //编辑回显
    if (!editData) return
    const tempArr = editData?.tenantDrugName?.split('，')
    form.setFieldsValue({
      potionDrugName: editData?.potionDrugName,
      tenantDrugName: tempArr[0]
    })
    setIptArr(tempArr.filter((obj: any, num: number) => num >= 1).map((item: any) => {
      return {
        name: item
      }
    }))
  }, [editData, visible])
  useEffect(() => {   //报错确定按钮取消 loading
    setSureBtnLoading(false)
  }, [btnLoading])

  useEffect(() => {
    if (visible) {
      setSureBtnLoading(false)
    } else {
      setIptArr([])
      form.resetFields()
    }
  }, [visible])
  return (
    <Modal
      visible={visible}
      title={(editData ? '编辑' : '新增') + '目录'}
      okText="确认"
      cancelText="取消"
      width={700}
      onOk={() => {
        form.submit()
      }}
      onCancel={() => {
        onCancel();
      }}
      confirmLoading={sureBtnLoading}
    >
      <Form
        form={form}
        autoComplete='off'
        initialValues={{}}
        onFinish={(values) => {

          if (iptArr.filter((item: any) => item.name != '').length) {
            values.tenantDrugName = values.tenantDrugName + '，' + iptArr.filter((item: any) => item.name != '').map((v: any) => v.name).join('，')
          }
          onOk({ ...values, id: editData ? editData.id : undefined })
          setSureBtnLoading(true)
        }}
        labelCol={{
          span: 8
        }}
      >
        <Row >
          <Col span={21}>
            <Form.Item label="饮片厂药品名称" name='potionDrugName'
              rules={[
                {
                  required: true,
                  pattern: new RegExp(/^[\u4E00-\u9FA5A-Za-z0-9]{1,20}$/, "g"),
                  message: "请输入正确的饮片厂药品名称",
                },
              ]}
              getValueFromEvent={stringTrim}
            >
              <Input
                allowClear
                maxLength={30}

                placeholder='单行输入'
              />
            </Form.Item>
          </Col>
          <>
            <Col span={21}>
              <Form.Item label="机构药品名称" name='tenantDrugName' rules={[{
                required: true,
                pattern: new RegExp(/^[\u4E00-\u9FA5A-Za-z0-9]{1,20}$/, "g"),
                message: "请输入正确的机构药品名称",
              }]} getValueFromEvent={stringTrim}>
                <Input
                  allowClear
                  maxLength={30}
                  placeholder='单行输入'
                />
              </Form.Item>

            </Col>
            <div className={styles.iconWrap} onClick={addIConFn}><PlusCircleOutlined /></div>
          </>
          <Col span={15} push={7}>
            {
              iptArr.map((item: any, index: number) => {
                return (
                  <div key={index} style={{ display: 'flex', marginBottom: 20 }}>
                    <Input
                      allowClear
                      value={item.name}
                      maxLength={30}
                      onChange={(e) => {
                        const values = e.target.value
                        const reg = /^[\u4E00-\u9FA5A-Za-z0-9]{1,20}$/
                        if (!reg.test(values) && values) {
                          notification.error({
                            message: '请输入正确的机构药品名称'
                          })
                          return
                        }
                        const data = iptArr.map((obj: any, num: number) => {
                          if (num == index) {
                            return {
                              ...obj,
                              name: values
                            }
                          } else {
                            return obj
                          }
                        })
                        setIptArr(data)
                      }}
                      placeholder='单行输入'
                    />
                    <div className={styles.iconWrap2} onClick={() => setIptArr(iptArr.filter((v: any, num: number) => num !== index))}><MinusCircleOutlined /></div>
                  </div>
                )
              })
            }
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

